module.exports = __webpack_public_path__ + "static/img/android.ee481b0d.png";